import { ProfileServiceInterface } from "interfaces/profile-service"
import { BaseMmsMockService } from "services/mms/mock/entities-services/BaseMockService"
import { CommunicationService } from "services/mms/mock/CommunicationService"
import { FetchMockProps } from "types/mms-base"
import { UserInfo, UserContextType } from "types/user"

export class MockProfileService
    extends BaseMmsMockService
    implements ProfileServiceInterface
{
    constructor(communicationService: CommunicationService) {
        super(communicationService)
    }

    useGetSelfProfile = (): FetchApiProps => {
        const datas: FetchMockProps = {
            delay: 0,
            controllerFn: ({ user }) => {
                const entity = this.communicationService.entities.find(
                    (e) => e.id === user?.entity_id
                )

                const profileData: UserInfo = {
                    username: `${user?.firstName} ${user?.lastName}`,
                    email: `${user?.email}`,
                    entity: `${entity?.entity_name}`,
                    entityId: entity?.id || "",
                }
                return {
                    data: profileData,
                }
            },
        }
        return this.get(datas)
    }

    useResetPassword = (): FetchApiProps => {
        const datas: FetchMockProps = {
            delay: 200,
            controllerFn: () => {
                return {
                    status: 200,
                    data: { message: "OK" },
                }
            },
        }
        return this.get(datas)
    }

    useSelfContext = (): FetchApiProps => {
        const datas: FetchMockProps = {
            delay: 300,
            controllerFn: ({ user }) => {
                const entity = this.communicationService.entities.find(
                    (e) => e.id === user?.entity_id
                )

                const selfProfileContextData: UserContextType = {
                    last_name: user?.lastName || "",
                    first_name: user?.firstName || "",
                    email: user?.email || "",
                    emsp_partner_name: entity?.entity_name || "",
                    emsp_partner_id: entity?.id || "",
                    is_email_verified: true,
                    is_manager: true,
                    is_driver: false
                }
                return {
                    data: selfProfileContextData,
                }
            },
        }
        return this.get(datas)
    }

    useGetSelfEntity: () => FetchApiProps = () => {
        const datas: FetchMockProps = {
            delay: 0,
            controllerFn: ({ user }) => {
                const entity = this.communicationService.entities.find(
                    (e) => e.id === user?.entity_id
                )
                return {
                    data: {...entity,
                        numberOfDrivers: this.communicationService.numberOfDriversPerEntity(entity?.id || ""),
                        numberOfCards: this.communicationService.numberOfRfidCardsPerEntity(entity?.id || ""),
                    },
                }
            },
        }
        return this.get(datas)
    }

    usePostSendEmail: () => FetchApiProps = () => {
        const datas: FetchMockProps = {
            delay: 0,
            controllerFn: ({ user }) => {
                const entity = this.communicationService.entities.find(
                    (e) => e.id === user?.entity_id
                )
                return {
                    data: {...entity,
                        numberOfDrivers: this.communicationService.numberOfDriversPerEntity(entity?.id || ""),
                        numberOfCards: this.communicationService.numberOfRfidCardsPerEntity(entity?.id || ""),
                    },
                }
            },
        }
        return this.post(datas)
    }
}
